const ACCEPTED = ["image/png", "image/jpeg"];

export function validateLogo(file: {
  readonly type: string;
  readonly size: number;
}): string | null {
  if (!ACCEPTED.includes(file.type) || file.size === 0) {
    return "Use um PNG ou JPEG.";
  }
  return file.size > 2_000_000 ? "O logo passa de 2 MB." : null;
}
